<script setup lang="ts">
  import type { IFormSelector } from '@/components/types'
  import FormsAskQuestionFlowsV1 from '@/components/forms/ask-question/flows/V1.vue'

  const props = defineProps<{ blok: IFormSelector }>()
  const flows = {
    AskQuestionFlowV1: FormsAskQuestionFlowsV1
  }

  type FlowKeys = keyof typeof flows

  const currentFlow = computed(() => {
    const flow: string = props.blok.flow

    if (props.blok.flow && flow in flows) {
      return flows[flow as FlowKeys]
    }

    return null
  })
</script>
<template>
  <div
    v-if="currentFlow"
    class="w-full"
  >
    <ClientOnly>
      <component
        :is="currentFlow"
        v-bind="props.blok"
      />
      <template #fallback>
        <div class="fixed left-0 top-0 z-50 flex h-screen w-full items-center justify-center bg-black/25">
          <UiPlaneLoader />
        </div>
        <div class="flex h-160 items-center justify-center" />
      </template>
    </ClientOnly>
  </div>
</template>
